import { LOCAL_STORAGE_PERMISSIONS } from '../../consts/common';

// Historical review/bypass require explicit grants, including for system admins.
export function historyPermissions(subjectId, objectType = 'asset', objectId) {
  let permissions;
  try {
    permissions =
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)) || {};
  } catch {
    permissions = {};
  }
  const grants = permissions.crud || [];
  const admin = grants.includes('super');
  const has = (id, action) =>
    (permissions[id] || []).some((p) => p.split('.')[1] === action);
  const subjectEdit =
    admin || (has(subjectId, 'view') && has(subjectId, 'update'));
  const relatedEdit =
    admin ||
    objectType === 'asset' ||
    (objectType === 'party' &&
      grants.includes('party.view') &&
      grants.includes('party.update')) ||
    (objectType === 'service' && grants.includes('service.view')) ||
    (objectType === 'contract' &&
      has(objectId, 'view') &&
      has(objectId, 'update'));
  return {
    edit: subjectEdit && relatedEdit,
    review: grants.includes('historical_data.review'),
    bypass: grants.includes('historical_data.bypass_approval')
  };
}

export function correctionError(error) {
  const status = error?.response?.status;
  if (status === 409)
    return 'This history or field changed. Reload before submitting a new correction. Pending corrections may need to be rejected and resubmitted.';
  if (status === 403)
    return 'You no longer have permission for this action, or this is your own submission.';
  if (status === 404)
    return 'This record is no longer available. Reload to see the latest records.';
  if (status === 400)
    return 'The value or date is no longer valid. Check the value, use Clear field to remove it, or reload the history.';
  return 'The result could not be confirmed. Retry to safely check the same request before making another change.';
}

export function editorValue(field, value) {
  if (field.field_type === 'multiselect')
    return Array.isArray(value)
      ? value
      : value
        ? String(value)
            .split(',')
            .map((v) => v.trim())
        : [];
  return value ?? (field.field_type === 'checkbox' ? false : '');
}

export function typedValue(field, value) {
  if (field.field_type === 'checkbox')
    return value === true || value === 'true';
  if (field.field_type === 'number') return value === '' ? null : Number(value);
  return value;
}

export function canViewHistoryApprovals() {
  try {
    const permissions = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)) || {};
    return historyPermissions().review || historyPermissions().bypass ||
      (permissions.crud || []).includes('super') ||
      Object.values(permissions).some(grants => Array.isArray(grants) && grants.some(grant => /^(asset|entities)\.update$/.test(grant)));
  } catch { return false; }
}
